import { isFeatureEnabled } from 'owa-feature-flags';
import { Features } from './Features';
import IsGroupsEnabled from './IsGroupsEnabled';
var IsFeatureEnabled = function (feature) {
    return isFeatureEnabled(feature);
};
export { IsFeatureEnabled, Features, IsGroupsEnabled };
//# sourceMappingURL=index.js.map